import { useState, useCallback, useEffect } from 'react';
import { TableResource } from '../Pages/Resources/types';

export const useResourceSelection = () => {
  const [selected, setSelected] = useState<number[]>([]);

  useEffect(() => {
    return () => setSelected([]);
  }, []);

  const onRowSelect = useCallback((selectedRows: TableResource[]) => {
    setSelected(selectedRows.map((row) => row.id));
  }, []);

  return { selected, onRowSelect, setSelected };
};
